import {
  Bar,
  Label,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ComposedChart,
  Line,
} from 'recharts'
import ChartWrapper from './ChartWrapper'

import {
  COLORS,
  convertToPercents,
  tooltipFormatter,
  tooltipLabelFormatter,
  yaxisFormatter,
} from '../helpers'
import { useChartViewState } from '../hooks/useChartViewState'

export default function ReferralDepositDiscountRebateChart(props) {
  const { data, loading, chartHeight, yaxisWidth } = props

  const csvFields = [
    { key: 'depositDiscountsTotal', name: 'Discount' },
    { key: 'depositRebatesTotal', name: 'Rebate' },
  ]

  const controls = {}

  const { viewState, togglePercentView, formattedData, ...viewSettings } =
    useChartViewState({ controls, data })

  return (
    <ChartWrapper
      title="Total Deposit Discount & Rebates"
      loading={loading}
      csvFields={csvFields}
      data={formattedData}
      controls={controls}
      viewState={viewState}
      togglePercentView={togglePercentView}
    >
      <ResponsiveContainer width="100%" height={chartHeight}>
        <ComposedChart data={formattedData} syncId="">
          <CartesianGrid strokeDasharray="10 10" />
          <XAxis
            dataKey="timestamp"
            tickFormatter={tooltipLabelFormatter}
            minTickGap={30}
          />
          <YAxis
            dataKey="depositTotal"
            interval="preserveStartEnd"
            tickCount={viewState.isPercentsView ? undefined : 7}
            tickFormatter={viewSettings.yaxisTickFormatter}
            width={yaxisWidth}
          />

          <YAxis
            dataKey="depositCumulative"
            orientation="right"
            yAxisId="right"
            tickFormatter={yaxisFormatter}
            width={yaxisWidth}
          />

          <Tooltip
            formatter={tooltipFormatter}
            labelFormatter={tooltipLabelFormatter}
            contentStyle={{ textAlign: 'left' }}
          />

          <Legend />

          <Bar
            unit={viewSettings.itemsUnit}
            isAnimationActive={false}
            type="monotone"
            dataKey="depositDiscountsTotal"
            stackId="a"
            name="Discount"
            fill={COLORS[2]}
          />
          <Bar
            unit={viewSettings.itemsUnit}
            isAnimationActive={false}
            type="monotone"
            dataKey="depositRebatesTotal"
            stackId="a"
            name="Rebate"
            fill={COLORS[3]}
          />
          <Line
            isAnimationActive={false}
            type="monotone"
            dot={false}
            strokeWidth={3}
            stroke={COLORS[4]}
            dataKey="depositDiscountsCumulative"
            yAxisId="right"
            name="Discounts Cumulative"
          />
          <Line
            isAnimationActive={false}
            type="monotone"
            dot={false}
            strokeWidth={3}
            stroke={COLORS[12]}
            dataKey="depositRebatesCumulative"
            yAxisId="right"
            name="Rebates Cumulative"
          />
        </ComposedChart>
      </ResponsiveContainer>
    </ChartWrapper>
  )
}
